import React, { useState } from 'react';
import { Search, ShoppingCart, User, Phone, Menu, X } from 'lucide-react';
const NAV_LINKS = [{
  label: 'PRODUCTS',
  href: 'https://www.6gtools.com/#ProductsMenu'
}, {
  label: 'TECHNICAL INFO',
  href: '#'
}, {
  label: 'BLOG',
  href: 'https://blog.6gtools.com/'
}, {
  label: 'CONTACT US',
  href: 'https://www.6gtools.com/products/contact-us.html'
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 shadow-sm" data-id="element-42">
      {/* Top Utility Bar */}
      <div className="bg-brand-charcoal text-white py-1.5 px-4 text-xs font-medium" data-id="element-43">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-44">
          <div className="flex items-center gap-4" data-id="element-45">
            <span className="flex items-center gap-1" data-id="element-46">
              <Phone className="w-3.5 h-3.5 text-brand-darkGold" data-id="element-47" />
              866.212.3385
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-48">
            <a href="#" className="hover:text-brand-lightGold transition-colors" data-id="element-49">
              New Account
            </a>
            <span className="text-gray-500" data-id="element-50">|</span>
            <a href="#" className="hover:text-brand-lightGold transition-colors flex items-center gap-1" data-id="element-51">
              <User className="w-3.5 h-3.5" data-id="element-52" />
              Login
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-53">
        <div className="flex flex-wrap md:flex-nowrap items-center justify-between gap-4 md:gap-8" data-id="element-54">
          {/* Logo */}
          <a href="/" className="flex-shrink-0" data-id="element-55">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.6gtools.com/uploaded/images/Redesign/6GTools-SM-logo.webp" alt="6G Tools" className="h-12 object-contain" data-id="element-56" />
          </a>

          {/* Search */}
          <div className="flex-grow max-w-2xl order-3 md:order-2 w-full md:w-auto" data-id="element-57">
            <div className="flex w-full" data-id="element-58">
              <input type="text" placeholder="SKU or Keywords" className="w-full border border-gray-300 rounded-l-md px-4 py-2 focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-59" />
              <button className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-semibold px-6 py-2 rounded-r-md flex items-center gap-2 transition-colors" data-id="element-60">
                <Search className="w-4 h-4" data-id="element-61" />
                <span className="hidden sm:inline" data-id="element-62">Search</span>
              </button>
            </div>
          </div>

          {/* Cart */}
          <div className="flex-shrink-0 order-2 md:order-3" data-id="element-63">
            <a href="#" className="flex items-center gap-3 group" data-id="element-64">
              <div className="relative" data-id="element-65">
                <ShoppingCart className="w-6 h-6 text-brand-charcoal group-hover:text-brand-darkGold transition-colors" data-id="element-66" />
                <span className="absolute -top-2 -right-2 bg-brand-red text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-67">
                  0
                </span>
              </div>
              <div className="hidden sm:block text-sm font-semibold text-brand-charcoal" data-id="element-68">
                $0.00
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <nav className="md:hidden bg-brand-gray border-t border-gray-200" data-id="element-69">
        <div className="max-w-7xl mx-auto px-4" data-id="element-70">
          <button type="button" onClick={() => setMobileOpen(o => !o)} aria-expanded={mobileOpen} aria-controls="mobile-nav-menu" className="flex items-center gap-2 py-3 text-sm font-bold text-brand-charcoal" data-id="element-71">
            {mobileOpen ? <X className="w-5 h-5" data-id="element-72" /> : <Menu className="w-5 h-5" data-id="element-73" />}
            Menu
          </button>
          {mobileOpen && <ul id="mobile-nav-menu" className="pb-3 text-sm font-bold text-brand-charcoal border-t border-gray-200" data-id="element-74">
              {NAV_LINKS.map(link => <li key={link.label} data-id="element-75">
                  <a href={link.href} className="block py-3 border-b border-gray-200 last:border-b-0 hover:text-brand-red transition-colors" data-id="element-76">
                    {link.label}
                  </a>
                </li>)}
            </ul>}
        </div>
      </nav>

      {/* Desktop Navigation */}
      <nav className="hidden md:block bg-brand-gray border-t border-gray-200" data-id="element-77">
        <div className="max-w-7xl mx-auto px-4" data-id="element-78">
          <ul className="flex items-center gap-8 py-3 text-sm font-bold text-brand-charcoal" data-id="element-79">
            <li data-id="element-80">
              <a href="https://www.6gtools.com/#ProductsMenu" className="hover:text-brand-red transition-colors" data-id="element-81">
                PRODUCTS
              </a>
            </li>
            <li className="group relative" data-id="element-82">
              <a href="#" className="hover:text-brand-red transition-colors flex items-center gap-1" data-id="element-83">
                TECHNICAL INFO
              </a>
              {/* Dropdown */}
              <div className="absolute top-full left-0 mt-0 w-64 bg-white border border-gray-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50" data-id="element-84">
                <ul className="py-2 text-sm font-normal" data-id="element-85">
                  {['Tap Drill & Thread Engagement Calculator', 'Drill And Tap Size Chart', 'NPT Tap Drill Chart', 'Metric Drill and Tap Chart', 'Inch Tap Drill Size Chart', 'Screw And Drill Size Chart', 'End Mill Sizes', 'Speeds And Feeds Charts', 'Speeds And Feeds Calculator'].map((item, i) => <li key={i} data-id="element-86">
                      <a href="#" className="block px-4 py-2 hover:bg-brand-gray hover:text-brand-red transition-colors" data-id="element-87">
                        {item}
                      </a>
                    </li>)}
                </ul>
              </div>
            </li>
            <li data-id="element-88">
              <a href="https://blog.6gtools.com/" className="hover:text-brand-red transition-colors" data-id="element-89">
                BLOG
              </a>
            </li>
            <li data-id="element-90">
              <a href="https://www.6gtools.com/products/contact-us.html" className="hover:text-brand-red transition-colors" data-id="element-91">
                CONTACT US
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>;
}